// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3W0Jd","title":"Info_title__1HwfC","links":"Info_links__3241U","link":"Info_link__7GkiX","logo":"Info_logo__21yzK"};